import React from 'react';
import styled, { css } from 'styled-components';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { CDN_IMAGES_URL } from 'consts';
import { footerStyle } from 'styles/global';
import { isMobileSelector } from 'redux/selectors/global';

interface IProps {
  className?: string;
  dataTestId?: string;
}

const Certificate = ({ className, dataTestId = '' }: IProps) => {
  const { t } = useTranslation();
  const isMobile = useSelector(isMobileSelector);

  return (
    <Wrapper>
      <CertificateContainer
        className={className}
        data-testid={dataTestId || 'certificate'}
      >
        <PCIWrapper>
          {!isMobile && (
            <Description>
              <LockIcon src={`${CDN_IMAGES_URL}/lock-icon-v2.svg`} />
              <PCIMessage>{t('pci_message')}</PCIMessage>
            </Description>
          )}
          <PCI src={`${CDN_IMAGES_URL}/pci@3x.png`} alt="pci-certificate" />
        </PCIWrapper>
      </CertificateContainer>
    </Wrapper>
  );
};

export default Certificate;

const Wrapper = styled.div`
  ${({ theme }) => theme.view.isMobile && 'margin-top: 2rem'};
`;

const PCIWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const LockIcon = styled.img`
  position: relative;
  height: 1rem;
  width: 1rem;
  top: 0.1rem;
`;

const PCIMessage = styled.div`
  ${footerStyle};
  margin-right: unset;
  margin-left: 0.2rem;

  ${({ theme }) => {
    const { pciMessage } = theme.hcp || {};
    if (pciMessage) {
      return css`
        color: ${pciMessage?.color};
      `;
    }
  }}
`;

const CertificateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${({ theme }) => (!theme.view.isMobile ? '1.5rem' : '')};
`;

const Description = styled.div`
  display: flex;
  align-items: baseline;
  margin-right: 0.8rem;
`;

const PCI = styled.img`
  width: 4.7rem;
  height: 2.3rem;
`;
